import { LayoutBaseProps } from "@/atoms-react/layout-base/LayoutBase.react";
import Loader from "@/atoms-react/loader/Loader.react";
import { AuthApiClient } from "@/features/auth/api-client/api-client";
import { JwtType } from "@/features/auth/types";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { animatedNext } from "../../layout/AnimatedForm.react";
import Authenticate, { AuthenticateOutput } from "./authenticate/Authenticate.react";
import { RecoverPassword } from "./recover-password/index.react";
import { ResetPassword } from "./reset-password/index.react";
import TwoFaAuthenticate, {
  type TwoFaAuthenticateOutput
} from "./two-fa-authenticate/TwoFaAuthenticate.react";

export type LoginInput = {
  email?: string;
  password?: string;
  is2faActivated?: boolean;
};

export type LoginOutput = JwtType;

interface LoginRootProps extends LayoutBaseProps {
  input: LoginInput;
  onValidated?: (data: LoginOutput) => void;
  isLoading?: boolean;
}

function LoginRoot({ input, onValidated = () => {}, isLoading }: LoginRootProps) {
  const [authenticationState, setAuthenticationState] = useState<AuthenticateOutput>();
  const { step } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [checkToken, setCheckToken] = useState(false);
  //mettre autre part pour eviter de voir
  useEffect(() => {
    const handleExpiration = async () => {
      if (step === "reset") {
        try {
          await AuthApiClient.checkTokenReset(
            searchParams.get("id") as string,
            searchParams.get("token") as string
          );
          setCheckToken(true);
        } catch (_) {
          setCheckToken(false);
          navigate("/");
        }
      }
    };
    handleExpiration();
  }, []);

  if (step === "recover") {
    return <RecoverPassword />;
  }

  if (step === "reset") {
    if (!checkToken) return <Loader />;
    return <ResetPassword />;
  }

  if (authenticationState && authenticationState.is2FARequired) {
    return (
      <TwoFaAuthenticate
        input={{ email: input.email ?? "", password: authenticationState.password ?? "" }}
        onValidated={(data: TwoFaAuthenticateOutput) => onValidated(data)}
      />
    );
  }
  return (
    <Authenticate
      isLoading={isLoading}
      email={input.email ?? ""}
      is2faActivated={input.is2faActivated ?? false}
      onValidated={(data) => {
        if (!data.is2FARequired) {
          onValidated({ token: data.token });
        } else {
          animatedNext("forward", async () => setAuthenticationState(data));
        }
      }}
    />
  );
}

export default LoginRoot;
